export enum QueryKey {
  MY_PROFILE = "getIdentity", // RA
  USERS = "USERS",
  USER = "USER",
  REFERRAL_USER = "REFERRAL_USER",
  AFFILIATE_USER = "AFFILIATE_USER",
  VETTING_USER = "VETTING_USER",
  USER_PURCHASES = "USER_PURCHASES",
  USER_PURCHASE_DETAIL = "USER_PURCHASE_DETAIL",
  REFERRAL_INVITES_USERS = "REFERRAL_INVITES_USERS",
  REPORT = "REPORT",
  INVITE = "INVITE",
  SUBSCRIPTION_PLANS = "SUBSCRIPTION_PLANS",
  FEEDBACKS = "FEEDBACKS",
  ACTIVE_SUPPORT_CHATS = "ACTIVE_SUPPORT_CHATS",
  CHATS = "CHATS",
  AFFILIATE_PAYMENT_PERIODS = "AFFILIATE_PAYMENT_PERIODS",
  AFFILIATE_PAYMENT_AMOUNT = "AFFILIATE_PAYMENT_AMOUNT",
  CHAT_MESSAGES = "CHAT_MESSAGES",
  AFFILIATES = "AFFILIATES",
  AFFILIATE_PAYOUTS = "AFFILIATE_PAYOUTS",
  AFFILIATE_EARNINGS = "AFFILIATE_EARNINGS",
  AFFILIATE_ACQUIRED_USERS = "AFFILIATE_ACQUIRED_USERS",
  AFFILIATE_PAYMENTS_PER_MONTH = "AFFILIATE_PAYMENTS_PER_MONTH",
  FEATURE_FLAG = "FEATURE_FLAG",
  EVENT = "EVENT",
}
